import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import CstaffDashboard from './CstaffDashboard';
import DepadminDashboard from './DepadminDashboard';
import FtocDashboard from './FtocDashboard';
import FtoDashboard from './FtoDashboard';
import OitDashboard from './OitDashboard';

import './Dashboard.scss';
import CommandDashboard from "./CommandDashboard";

class DashboardContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    // TODO
  }

  componentWillUnmount() {
    // TODO
  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return !this.props.userContext;
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {this.props.userContext.scope === 'cstaff' && <CstaffDashboard />}
        {this.props.userContext.scope === 'chief' && <CstaffDashboard />}
        {this.props.userContext.scope === 'depadmin' && <CommandDashboard />}
        {this.props.userContext.scope === 'sup' && <FtocDashboard />}
        {this.props.userContext.scope === 'fto' && <FtoDashboard />}
        {this.props.userContext.scope === 'ftoc' && <FtocDashboard />}
        {this.props.userContext.scope === 'oit' && <OitDashboard />}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(DashboardContainer);
